module.exports = [{
      plugin: require('../../bamboo/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/drone/src/wj-build-task/BES@I18N-0/src/templates/acg-portal-en/layout.tsx"},
    },{
      plugin: require('../../bamboo/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[],"offsetY":0},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
